import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Plus, Trash2, Smartphone, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import MapView from "@/components/MapView";
import { API, errMsg, fmtTime } from "@/lib/api";
import { usePanel } from "./PanelContext";

export default function Couriers() {
  const { api, activeOrders } = usePanel();
  const [list, setList] = useState([]);
  const [f, setF] = useState({ name: "", phone: "" });
  const appUrl = `${window.location.origin}/kurye`;

  const load = () => api.get("/couriers").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async () => {
    if (!f.name.trim()) return toast.error("Kurye adı girin");
    try { const { data } = await api.post("/couriers", f); setF({ name: "", phone: "" }); load(); toast.success(`Kurye eklendi. Giriş kodu: ${data.code}`); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (c) => { if (window.confirm(`${c.name} silinsin mi?`)) { await api.delete(`/couriers/${c.id}`); load(); } };
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Kopyalandı"); };

  const points = [
    ...list.filter((c) => c.lat != null).map((c) => ({ lat: c.lat, lng: c.lng, label: `Kurye: ${c.name}`, color: "#0F1F45" })),
    ...activeOrders.filter((o) => o.lat != null && !o.table_id).map((o) => ({ lat: o.lat, lng: o.lng, label: `#${o.no}`, color: "#FF6B0A" })),
  ];

  return (
    <div className="space-y-6 rise" data-testid="couriers-page">
      <div><h1 className="text-3xl font-extrabold">Kurye Takip</h1><p className="text-sm text-slate-500">Siparişler ekranından kuryeye gönderilen siparişler kurye uygulamasına anında düşer.</p></div>
      <div className="grid xl:grid-cols-[1fr_380px] gap-6">
        <MapView points={points} className="h-[460px]" testId="couriers-map" />
        <div className="space-y-4">
          <div className="rounded-3xl bg-[#0F1F45] text-white p-5">
            <div className="flex items-center gap-2"><Smartphone className="text-[#FF6B0A]" /><p className="font-display font-bold">Kurye Uygulaması</p></div>
            <p className="text-sm text-white/70 mt-2">Kurye Android APK dosyasını indirip kurar ve kendisine verilen kurye kodunu girer. Gönderdiğiniz siparişler, harita ve müşteri telefonu uygulamada görünür.</p>
            <a href={`${API}/apk/gazi-sepet-kurye.apk`} download="gazi-sepet-kurye.apk" type="application/vnd.android.package-archive" className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#FF6B0A] hover:bg-[#E55A00] px-4 py-2 text-sm font-semibold" data-testid="courier-apk-download">Kurye APK İndir (Android)</a>
            <div className="mt-3 flex items-center gap-2 bg-white/10 rounded-xl p-2 text-sm">
              <span className="truncate flex-1 font-mono-num" data-testid="courier-app-url">{appUrl}</span>
              <Button size="icon" variant="ghost" className="text-white h-8 w-8" onClick={() => copy(appUrl)} data-testid="courier-app-url-copy"><Copy className="h-4 w-4" /></Button>
              <a href="/kurye" target="_blank" rel="noreferrer" data-testid="courier-app-open"><ExternalLink className="h-4 w-4" /></a>
            </div>
          </div>
          <div className="rounded-3xl bg-white border p-5 space-y-2">
            <p className="font-display font-bold">Kurye Ekle</p>
            <Input placeholder="Ad Soyad" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="courier-name-input" />
            <Input placeholder="Telefon" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="courier-phone-input" />
            <Button className="w-full rounded-full bg-[#FF6B0A] hover:bg-[#E55A00] gap-1" onClick={add} data-testid="courier-add-btn"><Plus className="h-4 w-4" />Ekle</Button>
          </div>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {list.map((c) => (
          <div key={c.id} className="rounded-3xl bg-white border p-5" data-testid={`courier-card-${c.id}`}>
            <div className="flex items-start gap-2">
              <div className="flex-1"><p className="font-semibold">{c.name}</p><p className="text-xs text-slate-500">{c.phone}</p></div>
              <Button size="icon" variant="ghost" className="text-red-600" onClick={() => del(c)} data-testid={`courier-delete-btn-${c.id}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
            <div className="mt-3 flex items-center gap-2">
              <span className="text-xs text-slate-500">Giriş kodu</span>
              <button onClick={() => copy(c.code)} className="font-mono-num font-bold text-lg tracking-widest text-[#FF6B0A]" data-testid={`courier-code-${c.id}`}>{c.code}</button>
            </div>
            <div className="mt-2 flex gap-4 text-xs text-slate-600">
              <span>Aktif sipariş: <b>{c.active_orders}</b></span>
              <span>{c.loc_at ? `Son konum: ${fmtTime(c.loc_at)}` : "Konum yok"}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
